package ai.jessie.shared.work

import kotlinx.serialization.Serializable

@Serializable
enum class WorkCalendarView {
    WEEK,
    MONTH,
}

@Serializable
data class WorkCalendarDay(
    val date: String,
    val totalMinutes: Int,
    val entries: List<WorkResponse>,
)

// UC-009 BR-045: every date is organisation-local and server-resolved; clients navigate with
// previousDate/nextDate instead of computing dates.
@Serializable
data class WorkCalendarResponse(
    val view: WorkCalendarView,
    val timeZone: String,
    val currentDate: String,
    val rangeStart: String,
    val rangeEnd: String,
    val previousDate: String,
    val nextDate: String,
    val totalMinutes: Int,
    val days: List<WorkCalendarDay>,
)
